module.exports = __webpack_public_path__ + "img/success.62186972.png";